import { UseQueryOptions } from 'react-query'
import { getTags } from './tags'

export const tagsQueryKey = {
  get: ['tags']
}

export const getTagsQuery: UseQueryOptions<string[], Error> = {
  queryKey: tagsQueryKey.get,
  queryFn: () => getTags()
}
